import { render, staticRenderFns } from "./DesignList.vue?vue&type=template&id=e4b802e4&scoped=true&"
import script from "./DesignList.vue?vue&type=script&lang=js&"
export * from "./DesignList.vue?vue&type=script&lang=js&"
import style0 from "./DesignList.vue?vue&type=style&index=0&id=e4b802e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b802e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4b802e4')) {
      api.createRecord('e4b802e4', component.options)
    } else {
      api.reload('e4b802e4', component.options)
    }
    module.hot.accept("./DesignList.vue?vue&type=template&id=e4b802e4&scoped=true&", function () {
      api.rerender('e4b802e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/DesignListSidebarMenu/DesignList.vue"
export default component.exports